import {Container} from 'pixi.js';
import {IAnimation} from '@gongxigames/framework/core/types';
import {Updatable} from '@gongxigames/framework/core/fragments/update/Updatable';
import {Spine} from '@gongxigames/framework/core/fragments/display/Spine';
import {AUTOMATION_META, AutomationMeta} from '@gongxigames/framework/core/fragments/Autotest';

export class SpineAnimation extends Updatable implements IAnimation {

    protected _spine: Spine;
    protected _skin: string;
    protected _name: string;
    protected _loop: boolean;
    protected _completeCallback?: Function;
    protected _completed = false;
    protected _duration = 0;

    constructor(spine: Spine, name: string, loop = false, skin = '') {
        super();

        this._spine = spine;
        this._name = name;
        this._loop = loop;
        this._skin = skin;
    }

    public setOnComplete(callback: Function): void {
        this._completeCallback = callback;
    }

    public start(): void {
        super.start();

        this._skin && this._spine.skeleton.setSkinByName(this._skin);
        const trackEntry = this._spine.state.setAnimation(0, this._name, this._loop);

        this._duration = trackEntry.animation.duration * 1000;

        if (!this._loop) {
            this._spine.state.addListener({
                complete: () => {
                    // we cannot destroy spine here because we're in the middle of Spine::update()
                    this._completed = true;
                }
            });
        }

        // initial state
        this.update(0);
    }

    public getDuration(): number {
        return this._duration;
    }

    public stop(): void {
        super.stop();

        if (this._spine.skeleton) {
            this._spine.destroy();
        }
    }

    public update(dt: number): void {
        this._spine.update(dt);

        if (this._completed) {
            this._completed = false;
            this._completeCallback && this._completeCallback();
            this.stop();
        }
    }

    public get container(): Container {
        return this._spine;
    }

    [AUTOMATION_META](): AutomationMeta {
        return this._spine[AUTOMATION_META]();
    }
}
